import { LifecycleType } from 'model/Lifecycle';

export type NavigationNode = {
  label: string;
  pattern?: string;
  href?: string;
  id?: string;
  key?: string;
  children?: NavigationNode[];
  pulseProjectId?: number;
  requiredRoles?: string[];
  lifecycleType?: LifecycleType;
  // Rendered as a non-clickable loader row, and only for direct children of a top-level group
  isLoading?: boolean;
  // Loader only: route patterns of the items it stands in for, so the group opens on a deep link
  patterns?: string[];
  // Loader only: the patterns count only while a lifecycle survey is the current sub project
  isForLifecycleSurveys?: boolean;
};

export const createLoadingNode = (
  id: string,
  label: string,
  patterns: string[],
  options: Pick<NavigationNode, 'isForLifecycleSurveys'> = {},
): NavigationNode => ({
  id,
  label,
  isLoading: true,
  patterns,
  ...options,
});

export const getNavigationNodeKey = (node: NavigationNode): string =>
  node.key ?? node.id ?? node.href ?? node.label;

export function mapNavigationNodes(
  nodes: NavigationNode[],
  mapper: (node: NavigationNode) => NavigationNode,
) {
  return nodes.map((node) => {
    let mappedNode = mapper(node);

    if (mappedNode.children) {
      mappedNode = {
        ...mappedNode,
        children: mapNavigationNodes(mappedNode.children, mapper),
      };
    }

    return mappedNode;
  });
}
